<template>
  <div role="complementary" :class="[baseCss, visible ? 'line-ripple-visible' : null, setBgColor()]" :style="{height}">
    <div :class="['transition-all', 'duration-500', 'absolute', 'block', setBgColor('rippleBgColor', 'rippleBgColorLightness')]" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'LineRipple',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('line-ripple', ['w-full', 'block', 'relative', 'select-none', 'pointer-events-none', 'outline-none'])
    }
  },
  props: {
    height: {
      type: String,
      default: '2px'
    },
    visible: {
      type: Boolean
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    bgColorLightness: {
      type: Number,
      default: 300
    },
    rippleBgColor: {
      type: String,
      default: 'black'
    },
    rippleBgColorLightness: {
      type: Number,
      default: null
    }
  }
}
</script>
<style>
.bcq-line-ripple div
{
  width: 0;
  height: inherit;
  left: 50%;
}

.line-ripple-visible.bcq-line-ripple div
{
  width: 100%;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/line-ripple/line-ripple.vue